import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { EMPTY_DASH } from '@/helpers/constants';
import { prettyFloatMoney } from '@/helpers/utils';
import { useGetDashboardBalance } from '@/query/queries/cash/useGetDashboardBalance';
import s from './index.module.scss';

export const DashBalanceInfo = () => {
  const { data: balance } = useGetDashboardBalance();
  const { t } = useTranslation('dashboard');
  return (
    <div className={s.wrapper}>
      <div className={s.block}>
        <p className="f-body">{t('dash_balance_info.your_cash_account')}</p>
        <p className={classnames(s.cash, 'f-h3 f-500 tl')}>
          {balance ? prettyFloatMoney(balance.available_cash) : EMPTY_DASH}
        </p>
        {!!balance?.frozen_amount && (
          <span>
            {t('dash_balance_info.incl_reserved_for_refinancing', {
              amount: prettyFloatMoney(balance.frozen_amount),
            })}
          </span>
        )}
      </div>
      <div className={s.block}>
        <p className="f-16">{t('dash_balance_info.outstanding_balance')}</p>
        <p className={classnames(s.loan, 'f-h3 f-500 tl')}>
          {balance ? prettyFloatMoney(balance.outstanding) : EMPTY_DASH}
        </p>
        {!!balance?.refinanced_outstanding && (
          <span>
            {t('dash_balance_info.incl_to_be_refinanced', {
              amount: prettyFloatMoney(balance.refinanced_outstanding),
            })}
          </span>
        )}
      </div>
    </div>
  );
};
